module.exports = __webpack_public_path__ + "static/media/arundel logo 2015 rgb150.13bc22de.jpg";